import { Selector } from '@ngxs/store';
import { AuthState } from '@state/auth';
import { BusinessState } from '@state/business';

export class LoginSelector {
	@Selector([BusinessState.getLoaded, AuthState.getLoading])
	static getLoginLoading(
		businessLoaded: boolean,
		userLoading: boolean,
	): boolean {
		return !businessLoaded && userLoading;
	}
}
